import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-list-items-skeleton',
    templateUrl: './list-items-skeleton.component.html',
    styleUrls: ['./list-items-skeleton.component.scss'],
    standalone: false,
})
export class ListItemsSkeletonComponent { }
